import api from '@/client/core/api'
import { DeleteTagResponse } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * DELETE /twitter_benchmark_campaign_posts/tags/:tagId
 */
export async function deleteTwBenchmarkTagById(
  tagId: number,
  groupId: number
): Promise<TwBenchmarkApiResult<DeleteTagResponse>> {
  const response = await api.delete<TwBenchmarkApiResponse<DeleteTagResponse>>(
    `/twitter_benchmark_campaign_posts/tags/${tagId}`,
    { params: { groupId } }
  )

  return handleApiResponse<DeleteTagResponse>(response)
}
